import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    ButtonGroup,
    Checkbox,
    FormControlLabel,
    Table,
    TableHead, TableRow, TableCell, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useRef, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useGetFacultiesQuery, useLazyGetGroupsByFacultyQuery} from "../store/faculty/facultyApi";
import MenuItem from "@mui/material/MenuItem";
import copyObject from "../utils/copyObject";
import {useGetStudentsInGroupQuery} from "../store/group/groupApi";
import {CheckBox, PrintOutlined, RemoveRedEye} from "@mui/icons-material";
import {useAttendanceByGroupWebReportMutation} from "../store/reports/reportsApi";
// import { usePDF } from 'react-to-pdf';
import generatePDF from 'react-to-pdf';

export default function AttendanceReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {data: facultiesData} = useGetFacultiesQuery();
    const [facultiesList, setFacultiesList] = useState([]);
    const [selectedFacultyId, setSelectedFacultyId] = useState(null);
    const [getGroupsQuery] = useLazyGetGroupsByFacultyQuery();
    const [groupsList, setGroupsList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const {data: studentsData} = useGetStudentsInGroupQuery({groupId: selectedGroupId});
    const [studentsList, setStudentsList] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    const [selectedEducationFormId, setSelectedEducationFormId] = useState();
    const [refresh, setRefresh] = useState(false);
    const [loadData] = useAttendanceByGroupWebReportMutation();
    const [reportData, setReportData] = useState(null);
    const borderStyle = {'border': '1px solid #dfe6e9'};
    // const { toPDF } = usePDF({filename: 'page.pdf'});
    const targetRef = useRef();
    
    useEffect(() => {
        if (facultiesData && facultiesList.length === 0) {
            setFacultiesList(copyObject(facultiesData.data));
        }
        
        if (studentsData?.data) {
            setStudentsList(copyObject(studentsData.data));
        }
    }, [facultiesData, studentsData]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }
    
    function dateName(date) {
        if (date === null || date === undefined)
            return '';
        
        const dateObj = new Date(date);
        let dayName = '';
        switch (dateObj.getDay()) {
            case 0: dayName = 'ВС'; break;
            case 1: dayName = 'ПН'; break;
            case 2: dayName = 'ВТ'; break;
            case 3: dayName = 'СР'; break;
            case 4: dayName = 'ЧТ'; break;
            case 5: dayName = 'ПТ'; break;
            case 6: dayName = 'СБ'; break;
            default: dayName = '?'; break;
        }
        
        return `${dayName}, ${toDateString(date)}`;
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleLoad = async () => {
        setIsLoading(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };
    
    async function handleChangeFacultyId(value) {
        setSelectedFacultyId(value);
        
        await getGroupsQuery({data: {facultyId: parseInt(value,10)}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setGroupsList(copyObject(fulfilled.data));  
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
        });
    }
    
    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    async function handleChangeGroupId(value) {
        setSelectedGroupId(value);
    }
    
    async function handlePrintClicked() {
        setIsLoading(true);
        generatePDF(targetRef, {filename: 'page.pdf'});
        setIsLoading(false);
    }

    async function handleLoadClicked() {
        setIsLoading(true);
        
        if (!startDate || !endDate) {
            alert('Выберите даты');
            setIsLoading(false);
            return;
        }
        
        const studentIds = studentsList.filter((stud) => stud.checked).map((stud) => parseInt(stud.key, 10));
        await loadData({data: {fromDate: startDate, toDate: endDate, studentIds}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setReportData(fulfilled.data);
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            alert('Ошибка');
        });
    }
    
    function handleCheckAll() {
        let checkState = true;
        if (studentsList.filter((item) => item.checked === true).length === studentsList.length) {
            checkState = false;
        }
        
        studentsList?.forEach((item) => {
            item.checked = checkState;
        });
        
        applyVisualChanges();
    }
    
    function disciplineColumn(name) {
        return <TableCell align={'center'} style={borderStyle}>
            <Typography sx={{textOrientation: 'sideways', writingMode: 'vertical-lr', transform: 'rotate(180deg)'}} align={'center'}>
                {name.value} - {name.key} пара
            </Typography>
        </TableCell>
    }
    
    function numberOfColumns() {
        let sum = 0;
        reportData?.columns?.forEach((date) => {
            sum+=date.disciplines.length;
        })
        
        return sum;
    }
    
    function numberOfSkippedLessons(row) {
        const skipSymbol = '✕';
        return row.results.filter((item) => item === skipSymbol).length;
    }
    
    function totalNumberOfLessons(row) {
        return row.results.filter((item) => item !== ' ').length;
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Посещаемость по группам`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {facultiesData === null || facultiesData === undefined ? <CircularProgress /> : <></>}
                            Посещаемость по группам
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack spacing={2} direction={'row'} alignItems={'center'}>
                                    <Typography>Дата начала</Typography>
                                    <TextField type={'date'} fullWidth size={'small'} value={startDate} onChange={(event) => setStartDate(event.target.value)} />
                                    <Typography>Дата окончания</Typography>
                                    <TextField type={'date'} fullWidth size={'small'} value={endDate} onChange={(event) => setEndDate(event.target.value)} />
                                </Stack>

                                <Stack spacing={2} direction={'row'}>
                                    <TextField label={'Факультет'}
                                               select
                                               value={selectedFacultyId}
                                               onChange={(event) => {handleChangeFacultyId(event.target.value)}}
                                               fullWidth
                                               size={'small'} >
                                        {facultiesList?.sort((l,r) => l.value > r.value ? 1 : -1).map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </TextField>

                                    <TextField label={'Группа'}
                                               select
                                               value={selectedGroupId}
                                               onChange={(event) => {handleChangeGroupId(event.target.value)}}
                                               fullWidth
                                               size={'small'} >
                                        {groupsList?.sort((l,r) => l.value > r.value ? 1 : -1).map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </TextField>
                                </Stack>

                                {studentsList && studentsList.length > 0
                                ? <Stack>
                                        <Stack direction={'row'}>
                                            <Button onClick={() => {handleCheckAll()}}>Отметить всех</Button>
                                        </Stack>
                                        {studentsList?.sort((l,r) => l.value > r.value ? 1 : -1)
                                            .map((item) => {
                                                return <FormControlLabel control={<Checkbox size={'small'} checked={item.checked ?? false} onChange={(event, checked) => {item.checked = checked; applyVisualChanges()}} />} label={item.value} />
                                            })}
                                    </Stack>
                                : <></>}
                                
                                <ButtonGroup size={'small'} orientation={'vertical'} disabled={isLoading} fullWidth>
                                    {/* <Button variant={'outlined'} startIcon={<PrintOutlined />} onClick={() => handlePrintClicked()}>Печать</Button> */}
                                    <Button variant={'contained'} startIcon={<RemoveRedEye />} onClick={() => handleLoadClicked()}>Просмотреть</Button>
                                </ButtonGroup>
                            </Stack>
                        </CardContent>
                    </Card>

                    {reportData
                    ? <Card ref={targetRef}>
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell rowSpan={3} style={borderStyle}>№</TableCell>
                                            <TableCell style={borderStyle}>ФИО</TableCell>
                                            <TableCell colSpan={numberOfColumns() + 1} style={borderStyle}>Период {toDateString(startDate)} - {toDateString(endDate)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={borderStyle}>Дата</TableCell>
                                            {reportData.columns.map((item) => {
                                                return <TableCell colSpan={item.disciplines.length}
                                                                  align={'center'}
                                                                  style={borderStyle}>{dateName(item.columnDate)}</TableCell>
                                            })}
                                            <TableCell rowSpan={2} style={borderStyle}>Итого</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={borderStyle}>Предмет</TableCell>
                                            {reportData.columns.map((col) => {
                                                return col.disciplines.map((disc) => disciplineColumn(disc))
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {reportData.rows?.map((item, index) => {
                                            return <TableRow>
                                                <TableCell style={borderStyle}>{index + 1}</TableCell>
                                                <TableCell style={borderStyle}>{item.fullName}</TableCell>
                                                {item.results.map((res) => {
                                                    return <TableCell style={borderStyle}
                                                        align={'center'}><Typography color={res === '✕' ? 'red' : res === ' ' ? 'black' : res === 'У' ? 'orange' : 'green'}>{res}</Typography></TableCell>
                                                })}
                                                <TableCell style={borderStyle} align={'center'}>{numberOfSkippedLessons(item)}/{totalNumberOfLessons(item)}</TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    : <></>}
                    
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
